import "./FeelimImageAnimation.css";

/**
 * "Feelim is creating an image" loading animation — shown while an image
 * is being generated (see PostSelection.jsx handleGenerateImage).
 */
export default function FeelimImageAnimation({ className = "" }) {
  return (
    <div className={`feelim-image-anim ${className}`.trim()} role="img" aria-label="Feelim is creating an image">
      <svg className="canvas-svg" viewBox="0 0 280 360" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g transform="translate(14,54) scale(10.5)">
          <rect className="icon-part icon-rect" x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <circle className="icon-part icon-circle" cx="8.5" cy="8.5" r="1.5" />
          <polyline className="icon-part icon-mountain" points="21 15 16 10 5 21" />
        </g>
      </svg>

      <div className="logo-wrap">
        <svg className="feelim-mark" viewBox="0 -14 120 154" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect x="10" y="-8" width="100" height="116" rx="24" fill="#2DEA89" />
          <path
            d="M 22 36
               C 22 18, 38 9, 60 9
               C 82 9, 98 18, 98 36
               C 98 54, 85 64, 68 66.5
               C 66 69, 64 76, 58 82
               C 60 74, 59 69, 56 66.5
               C 34 64, 22 54, 22 36 Z"
            fill="#0a0a0a"
          />
          <circle className="eye eye-l" cx="46" cy="38" r="6.5" fill="#ffffff" />
          <circle className="eye eye-r" cx="71" cy="33" r="8.2" fill="#ffffff" />
          <rect x="10" y="96" width="100" height="34" rx="14" fill="#0a0a0a" />
          <circle className="dot dot-1" cx="38" cy="113" r="5" fill="#ffffff" />
          <circle className="dot dot-2" cx="60" cy="113" r="5" fill="#ffffff" />
          <circle className="dot dot-3" cx="82" cy="113" r="5" fill="#ffffff" />
        </svg>
      </div>
    </div>
  );
}
